import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { UserRoleEnum } from '../../enums/user-role-enum';
import { MenuItemsComponent } from '../menu-items/menu-items.component';
declare var $: any;
import { User } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'admin-menu',
  standalone: true,
  imports: [RouterModule, CommonModule, MenuItemsComponent],
  templateUrl: './admin-menu.component.html',
  styleUrl: './admin-menu.component.css',
})
export class AdminMenuComponent implements OnInit {
  // authUser = localStorage.getItem('FLOCurrentUser');
  // loginedUser = this.authUser ? JSON.parse(this.authUser) : '';
  role: any;
  userRole = UserRoleEnum;
  loggedUser: User = new User();
  projectName: any;
  constructor(private authService: AuthService) {}
  ngOnInit(): void {
    this.loggedUser = this.authService.CurrentUserValue;
    this.role = this.loggedUser.role;
    this.projectName = this.loggedUser.project_name;
    this.jQueryEvents();
  }

  jQueryEvents(): void {
    $('div.jq-site-wrap').on('click', 'div.jq-menu-icon-wrap', function () {
      if ($('div.jq-site-wrap aside').hasClass('sidebar_large')) {
        $('div.jq-site-wrap aside').removeClass('sidebar_large');
        $('div.jq-site-wrap main').addClass('main-content_lg');
      } else {
        $('div.jq-site-wrap aside').addClass('sidebar_large');
        $('div.jq-site-wrap main').removeClass('main-content_lg');
      }
    });
  }
}
